export default __webpack_public_path__ + "static/logo_fr-dad3feaa2b14b479399c6865947690de.png";